import omit from 'lodash/omit';

export default (state, action) => {
  const { itemCount } = state;
  const { containerId } = action.payload;

  const updatedItemCount = omit(itemCount, containerId);

  return {
    ...state,
    itemCount: updatedItemCount,
  };
};
